import { useState, useEffect, useRef } from "react";

import PropTypes from "prop-types";

import { useRouter } from "next/router";

import store from "store2";
import { v4 as uuid } from "uuid";
import { format } from "date-fns";

import { KTPost, KTGet } from "../../../../lib/db";

import { useQuery } from "react-query";

import { useFormik } from "formik";

import { UserSchema } from "@/kyna/lib/validations/UserSchema";
import InputForm from "@/kyna/forms/InputForm";

import bcrypt from "bcryptjs";

import Spinner from "@/kyna/ui/preloader/Spinner";

import slugify from "react-slugify";

import KNDatePicker from "@/kyna/ui/datepicker";
import KNModal from "@/kyna/ui/modal/KNModal";
import KNModalBody from "@/kyna/ui/modal/KNModalSchemaErrors";
import { isEmpty } from "lodash";
import produce from "immer";
const UserSession = store.get("UserSession");

import toast, { Toaster, ToastBar } from "react-hot-toast";
import { KNThemeSuccess, KNThemeError } from "@/kyna/ui/toaster/KNTheme";
import KNToaster from "@/kyna/ui/toaster/KNToaster";
import { Widget } from "@uploadcare/react-widget";
const NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY =
  process.env.NEXT_PUBLIC_UPLOADCARE_PUBLIC_KEY;
import { Transition } from "@headlessui/react";

const UserFields = {
  first_name: "",
  middle_name: "",
  last_name: "",

  contact_no: "",
  gender: "",

  user_role_id: "",
};
const getApplicants = async (params) => {
  return await KTGet("/api/applicants");
};
const getPatients = async (params) => {
  return await KTGet("/api/patients");
};
const getUsers = async () => {
  return await KTGet("/api/users/applicant", {
    limit: 1,
    orderBy: "modified,desc",
  });
};

const AddUserModal = (props) => {
  const router = useRouter();
  const { slug } = router.query;

  const [isLoading, setLoading] = useState(false);
  const [formMessage, setFormMessage] = useState(null);
  const [formMessageType, setFormMessageType] = useState(null);
  const [dataIsLoaded, setDataLoaded] = useState(false);
  const [formResponse, setFormResponse] = useState({});
  const [cvPicURL, setCVPic] = useState(null);

  const [checkedIds, setChekedIds] = useState([]);
  const [checkedServices, setcheckedServices] = useState([]);
  const [userIntialValues, setFormValues] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    contact_no: "",
    gender: "",
    reference_code: "",
    email: "",
    password: "",
    postKey: "",
    user_role_id: "",
    user_role_name: "",
    jobs_id: "",
  });
  const [formInputIntialValues, setFormInputValues] = useState(UserFields);
  const [primaryID, setPrimaryID] = useState(0);

  const [SchemaErrors, setSchemaErrors] = useState({});
  console.log("props: teest", props);
  console.log("router:", router.route);
  // PAGE MODAL
  let [modalIconType, setModalIcon] = useState("info");
  let [modalTitle, setModalTitle] = useState("Add New User");
  let [modalDescription, setModalDescription] = useState("");
  let [modalBody, setModalBody] = useState("");
  let [isModalOpen, setModalOpen] = useState(false);
  const getUserRoles = async () => {
    return await KTGet("/api/maintenance/user_roles", {
      limit: 100,
      orderBy: "modified,asc",
    });
  };
  const getServices = async () => {
    return await KTGet("/api/maintenance/_service", {
      limit: 100,
      orderBy: "modified,asc",
      sub_category: "Booking",
    });
  };

  // USEQUERY
  const {
    data: userRoles,
    status: UserRoleStatus,
    isLoading: UserRoleIsLoading,
  } = useQuery("userRoles", getUserRoles);
  console.log("userRoles", userRoles);

  const {
    data: ServicesData,
    status: ServicesDataStatus,
    isLoading: ServicesIsLoading,
  } = useQuery("ServicesData", getServices);
  console.log("ServicesData", ServicesData);

  const acceptedURLs = ["security", ""];
  const handlechange = (e) => {
    const clickedId = +e.target.value;
    if (checkedIds.includes(clickedId)) {
      setChekedIds(checkedIds.filter((id) => id !== clickedId));
      formik.setFieldValue(ServicesData.name);
    } else {
      setChekedIds([...checkedIds, clickedId]);
    }
  };

  const isCheked = (id) => {
    checkedIds.includes(id);
  };
  useEffect(() => {
    if (router?.route == "/app/doctors") {
      setModalTitle("Add New Doctor");
    }
  }, [router]);
  const submitHandler = async (values) => {
    setLoading(true);
    setFormMessage(null);
    setFormMessageType(null);
    console.log("Submit");
    console.log("Submit values: ", values);
    console.log("Submit props: ", props?.data);

    // return;

    const applicantsData = await getApplicants();
    console.log("applicantsData", applicantsData?.data?.info?.resultCount + 1);
    const patientsData = await getPatients();
    console.log(
      "patientsData",
      patientsData?.data?.result[patientsData?.data?.result?.length - 1]?.id + 1
    );
    // return

    const hashedPassword = await bcrypt.hash(values.password, 10);
    // const modifiedDatetime = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    const modifiedDatetime = new Date();
    console.log("modifiedDatetime", modifiedDatetime);

    const enrollment_date =
      values.enrollment_date != null ? new Date(values.enrollment_date) : null;
    console.log("enrollment_date", enrollment_date);

    if (values.user_role_id == 20) {
      let patientData = {
        patient: {
          patient_no: format(new Date(), "yyyy") + "-" + uuid().substring(0, 6),
          enrollment_date: new Date(),
        },
        patient_no: format(new Date(), "yyyy") + "-" + uuid().substring(0, 6),
        enrollment_date: new Date(),
      };
      const result = await KTPost("/api/patients/user-patient", patientData);
      if (result.status != 200) {
        console.log("error");
        console.log(result.error);
        // alert("");
        // setFormMessage("There's an error occur, please try again.")
        // setFormMessageType("text-red-400")
        toast.dismiss();
        toast.error("There's an error occur, please try again.", {
          ...KNThemeError,
        });

        return;
      }

      if (result.status == 200 && result.data.code == 422) {
        console.log("error");
        console.log(result);

        setSchemaErrors(result.data.schemaErrors);

        props.errorCallback({
          schemaErrors: result.data.schemaErrors,
          modalIcon: "error",
          modalTitle: "Form validation error",
        });

        toast.dismiss();
        toast.error("Patient already exist!", { ...KNThemeError });

        setLoading(false);
        return;
      }
    }

    let postData = {
      section: "General",
      user: {
        account_no: "",
        username: values.email,
        password: hashedPassword,
        // new_password: hashedPassword,
        status: "Active",
        user_role_id: [1, 2, 13, 14, 16, 17].includes(
          UserSession?.result?.user_role_id
        )
          ? parseInt(values.user_role_id)
          : 21, // DONE:TODO, ADD TO THE GLOBAL CONFIG FOR PUBLIC REGISTRATION  #TODO hardcoded

        modified: modifiedDatetime,
      },

      person: {
        first_name: values.first_name,
        last_name: values.last_name,
        middle_name: values.middle_name,
        gender: values.gender,
        contact_no: values.contact_no,
        email: values.email,
        license_no: values.license_no,
        modified: modifiedDatetime,
        applicant_id: ![1, 2, 13, 14, 16, 17].includes(
          UserSession?.result?.user_role_id
        )
          ? applicantsData?.data?.info?.resultCount + 1
          : null,
        patient_id:
          values.user_role_id == 20
            ? patientsData?.data?.result[patientsData?.data?.result?.length - 1]
                ?.id + 1
            : null,
      },
    };

    // COMPUTATION, MODIFICATION AND OTHER LOGIC HERE

    if (primaryID) {
      postData.id = primaryID;
    }

    // console.log("postData", postData);
    // return
    const saveUserResponse = {};

    if ([1, 2, 13, 14, 16, 17].includes(UserSession?.result?.user_role_id)) {
      saveUserResponse = await KTPost("/api/users", postData);
    } else {
      saveUserResponse = await KTPost("/api/users/applicant", postData);
    }

    setLoading(false);
    setFormResponse(saveUserResponse);
    console.log("Register post saveUserResponse", saveUserResponse);

    if (saveUserResponse.status != 200) {
      console.log("error");
      console.log(saveUserResponse.error);
      // alert("");
      // setFormMessage("There's an error occur, please try again.")
      // setFormMessageType("text-red-400")
      toast.dismiss();
      toast.error("There's an error occur, please try again.", {
        ...KNThemeError,
        position: "top-center",
        duration: 800000,
      });

      return;
    }

    if (saveUserResponse.status == 200 && saveUserResponse.data.code == 422) {
      console.log("error");
      console.log(saveUserResponse);

      setSchemaErrors(saveUserResponse.data.schemaErrors);

      props.errorCallback({
        schemaErrors: saveUserResponse.data.schemaErrors,
        modalIcon: "error",
        modalTitle: "Form validation error",
      });

      // setModalOpen(true)
      // setModalIcon('error')
      // setModalTitle('Form validation error')
      toast.dismiss();
      toast.error("User already exist!", {
        ...KNThemeError,
        position: "top-center",
        duration: 800000,
      });

      setLoading(false);
      return;
    }

    let userService_data = {};

    userService_data = await KTGet("/api/users", {
      limit: 1000,
      orderBy: "modified,desc",
    });
    console.log("userService_data: ", userService_data);

    console.log("checkedServices", checkedServices);

    if (checkedServices != null) {
      let serviceData = [];

      checkedServices.map((data, index) => {
        console.log("userService: ", data, index);
        serviceData.push({
          name: data.name,
          service_id: data.service_id,
          user_id: userService_data.data.result[0].id,
        });
      });

      console.log("serviceData: ", serviceData);
      console.log("UserSession: ", UserSession);

      // return;

      // if (primaryID) {
      //     doctorPostData.id = primaryID;
      // }

      let postData = {
        // user_id: parseInt(UserSession.result.id),
        user_service_data: serviceData,
      };

      if (primaryID) {
        postData.id = primaryID;
      }

      const saveUserServiceResponse = await KTPost(
        "/api/users/user_services",
        postData
      );

      console.log("saveUserServiceResponse", saveUserServiceResponse);
    }
    if (UserSession?.result?.user_role_id != 1) {
      let postData = {
        jobs_id: router?.query?.id ? router?.query?.id : null,
      };

      const saveApplicantResponse = await KTPost("/api/applicants", postData);

      console.log("saveApplicantResponse", saveApplicantResponse);

      toast.dismiss();
      toast.success("Application has been sent!", {
        ...KNThemeSuccess,
        position: "top-center",
      });

      await KTPost(`/api/activity_logs`, {
        logs: {
          title: "Job Applicant",
          description:
            "Applying for " +
            props?.data.data?.result?.title +
            "-" +
            props?.data.data?.result?.job_type,
          email: values.email,
        },
      });
      const res = await fetch("/api/sendgrid", {
        body: JSON.stringify({
          email: "cisd@pmha.org.ph",
          contact_no: values.contact_no,
          fullname: values.last_name + ", " + values.first_name,
          subject: "Job Applicant",
          // message: message.props.initialValue[0].children[0].text,
          html: `
        <!doctype html>
        <html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">
        
        <head>
          <title>Jobs</title>
          <meta http-equiv="X-UA-Compatible" content="IE=edge">
          <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <style type="text/css">
            #outlook a {
              padding: 0;
            }
            body {
              margin: 0;
              padding: 0;
              -webkit-text-size-adjust: 100%;
              -ms-text-size-adjust: 100%;
            }
            table, td {
              border-collapse: collapse;
              mso-table-lspace: 0pt;
              mso-table-rspace: 0pt;
            }
            img {
              border: 0;
              height: auto;
              line-height: 100%;
              outline: none;
              text-decoration: none;
              -ms-interpolation-mode: bicubic;
            }
            p {
              display: block;
              margin: 13px 0;
            }
          </style>
          
          <link href="https://fonts.googleapis.com/css?family=Quattrocento+Sans:400,700&display=swap" rel="stylesheet">
          <style type="text/css">
            @import url(https://fonts.googleapis.com/css?family=Ubuntu:300,400,500,700);
          </style>
          <style type="text/css">
            @media only screen and (min-width:480px) {
              .mj-column-per-100 {
                width: 100% !important;
                max-width: 100%;
              }
              .mj-column-per-50 {
                width: 50% !important;
                max-width: 50%;
              }
              .mj-column-per-33-333333333333336 {
                width: 33.333333333333336% !important;
                max-width: 33.333333333333336%;
              }
              .mj-column-per-30 {
                width: 30% !important;
                max-width: 30%;
              }
              .mj-column-per-70 {
                width: 70% !important;
                max-width: 70%;
              }
            }
          </style>
          <style type="text/css">
            @media only screen and (max-width:480px) {
              table.mj-full-width-mobile {
                width: 100% !important;
              }
              td.mj-full-width-mobile {
                width: auto !important;
              }
            }
          </style>
        </head>
        
        <body>
          <div style="background-color: #f1f1f1; padding: 20px 0;">
          <div style="margin: 0px auto; max-width: 600px; background-color: #fff;">
            <table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
              <tbody>
                <tr>
                  <td style="direction: ltr; font-size: 0px; padding: 40px 0 20px; text-align: center;">
                    <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width:100%;">
                      <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                        <tr>
                          <td align="center" style="font-size: 0px; padding: 10px 25px; word-break:break-word;">
                          <img height="auto" src='https://ucarecdn.com/65c28e90-eaaa-40a9-80a5-c49fe439a656/applogo.png' style="border: 0; display: block; outline: none; text-decoration: none; height: 150px; width:30%;" />
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 0px; padding: 30px 0 10px; word-break: break-word;">
                            <p style="border-top: solid 10px #193e8c; font-size: 1; margin: 0px auto; width:100%; "></p>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
            <div style="margin: 0px auto; max-width: 600px; background-color: #fff;">
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; font-size: 0px; padding: 20px 0; text-align: center;">
                      <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="center" style="font-size: 0px; padding: 10px 25px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 18px; font-weight: 700; text-transform: uppercase; letter-spacing: 2px; line-height: 1.2em; text-align: center; color:#111111;">Application for ${props?.data.data?.result?.title}</div>
                            </td>
                          </tr>
                          <tr>
                            <td align="center" style="font-size: 0px; padding: 10px 25px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 14px; line-height: 1.2em; text-align: center; color: #111111;"> ${props?.data.data?.result?.job_type}</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin: 0px auto; max-width: 600px; background-color: #fff;">
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; font-size: 0px; padding: 20px 0; text-align: center;">
                      <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 10px 25px 0; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 14px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; line-height: 1.4em; text-align: left; color: #111111;">Applicant Details</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin: 0px auto; max-width: 600px; background-color: #fff;">
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; font-size: 0px; padding: 0px 25px; text-align: center;">
                      <div class="mj-column-per-30 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; font-weight: 600; line-height: 1.4em; text-align: left; color: #111111;">Applicant Name:</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="mj-column-per-70 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; line-height: 1.4em; text-align: left; color: #111111;"> ${values.last_name},${values.first_name} ${values.middle_name}.</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin: 0px auto; max-width: 600px; background-color: #fff;">
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; font-size: 0px; padding: 0px 25px; text-align: center;">
                      <div class="mj-column-per-30 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; font-weight: 600; line-height: 1.4em; text-align: left; color: #111111;">Contact Number:</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="mj-column-per-70 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; line-height: 1.4em; text-align: left; color: #111111;">${values.contact_no}</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin: 0px auto; max-width: 600px; background-color: #fff;">
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; font-size: 0px; padding: 0px 25px; text-align: center;">
                      <div class="mj-column-per-30 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; font-weight: 600; line-height: 1.4em; text-align: left; color: #111111;">Gender: </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="mj-column-per-70 mj-outlook-group-fix" style="font-size: 0px ;text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; line-height: 1.4em; text-align: left; color: #111111;">${values.gender}</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin: 0px auto; max-width: 600px; background-color: #fff;">
              <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width: 100%;">
                <tbody>
                  <tr>
                    <td style="direction: ltr; font-size: 0px; padding: 0px 25px; text-align: center;">
                      <div class="mj-column-per-30 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; font-weight: 600; line-height: 1.4em; text-align: left; color: #111111;">Email Address:</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div class="mj-column-per-70 mj-outlook-group-fix" style="font-size: 0px; text-align: left; direction: ltr; display: inline-block; vertical-align: top; width: 100%;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align: top;" width="100%">
                          <tr>
                            <td align="left" style="font-size: 0px; padding: 0 25px 10px; word-break: break-word;">
                              <div style="font-family: 'Quattrocento Sans', sans-serif; font-size: 13px; line-height: 1.4em; text-align: left; color: #111111;">${values.email}</div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </body>
        </html>
        `,
        }),
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
      });
      const { error } = await res.json();
      if (error) {
        console.log(error);
        return;
      }
    } else {
      const response = await KTPost(`/api/activity_logs`, {
        /* TODO: #UserSession #Pending */
        logs: {
          title: "Created new user - " + values.email,
          description: values.user_role_name,
          user_id: UserSession?.result?.id,
          email: UserSession?.result?.username,
        },
      });
      toast.dismiss();
      toast.success("User has been saved!", {
        ...KNThemeSuccess,
        position: "top-center",
      });
    }
    props.successCallback();

    // return;
    setLoading(false);
    resetFormikValues();
    formik.resetForm();
  };
  const resetFormikValues = () => {
    console.log("resetFormikValues");
    Object.entries(UserFields).map((q, i) => {
      const key = q[0];
      // console.log("Q FIELD: " + key + ": " + UserFields[key])
      formik.setFieldValue(key, UserFields[key]);
      formik.setTouched({ UserFields }, false);
    });

    // setFieldPrimaryID(0)
  };

  const onModalClose = () => {
    props.closeModal(false);
    router.push({
      pathname: router.pathname,
      query: router.query,
    });
    formik.resetForm();
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: userIntialValues,
    validationSchema: UserSchema,
    onSubmit: (values) => {
      // alert(JSON.stringify(values, null, 2));
      // return
      submitHandler(values);
    },
  });

  // FOR HOMEPAGE Career
  useEffect(async () => {
    const applicantsData = await getApplicants();
    console.log("applicantsData", applicantsData?.data);
    console.log("UserSession", UserSession?.result);
    if (![1, 2, 13, 14, 16, 17].includes(UserSession?.result?.user_role_id)) {
      setFormValues(
        produce((draft) => {
          draft.user_role_id = 21;
          draft.jobs_id = router?.query?.id ? router?.query?.id : null;
        })
      );
      setDataLoaded(true);
      setModalTitle("Fill-out form");
      // if(formDataRes.data.result?.person?.user?.media?.[0]){
      //     setCVPic(formDataRes.data.result.person.user.media[0].path);
      // }
    }
  }, [modalTitle]);

  const saveMediaFile = async (mediaData) => {
    console.log("mediaData", mediaData);
    const primaryID = await getUsers();
    // console.log('test ROW:',primaryID?.data?.result?.id + 1) ;
    // // return
    let postData = {
      path: mediaData.cdnUrl,
      file_name: mediaData.name,
      orig_name: mediaData.name,
      attach_id: primaryID?.data?.result?.id + 1,
      attachment_for: "Applicant CV/Resume",
      user_id: primaryID?.data?.result?.id + 1,
      is_image: mediaData.isImage,
      reference_id: mediaData.uuid,
    };

    try {
      const result = await KTPost("/api/media/applicant", postData);
      if (result) {
      }
    } catch (error) {
      console.log("error media saving", error);
    }
  };

  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const doctor_name = "Doctor";
  useEffect(() => {
    if (router.route == "/app/doctors") {
      setFormValues(
        produce((draft) => {
          draft.user_role_id = 15;
        })
      );
      setDataLoaded(true);
    }
  }, []);
  return (
    <>
      <KNModal
        title={modalTitle}
        iconType={modalIconType}
        description={modalDescription}
        bodyClass={"max-w-4xl mt-10"}
        body={
          <ModalForm
            formik={formik}
            SchemaErrors={SchemaErrors}
            formMessage={formMessage}
            formMessageType={formMessageType}
            isLoading={isLoading}
            userRoles={userRoles}
            ServicesData={ServicesData}
            isCheked={isCheked}
            handlechange={handlechange}
            saveMediaFile={saveMediaFile}
            setCVPic={setCVPic}
            cvPicURL={cvPicURL}
            checkedServices={checkedServices}
            isData={props.data}
            doctor_name={doctor_name}
            router={router}
            setcheckedServices={setcheckedServices}
            onClose={() => {
              props.closeModal(false);
              formik.resetForm();
            }}
          />
        }
        isOpen={props.isModalOpen}
        noFooter={true}
        setModalOpen={(e) => {
          setModalOpen(e);
        }}
        closeModal={() => {
          onModalClose();
          // props.closeModal(false)
        }}
      />
      <KNToaster />
    </>
  );
};

const ModalForm = ({
  formik,
  isData,
  saveMediaFile,
  setCVPic,
  cvPicURL,
  SchemaErrors,
  formMessage,
  formMessageType,
  isLoading,
  onClose,
  userRoles,
  ServicesData,
  isCheked,
  doctor_name,
  router,
  handlechange,
  checkedServices,
  setcheckedServices,
}) => {
  return (
    <form onSubmit={formik.handleSubmit}>
      {UserSession?.result?.user_role_id != 1 ? (
        <>
          <div className="form-group mb-5">
            <div className="md:grid grid-cols-12 gap-10 gap-y-0">
              <div className="col-span-12 md:col-span-8 text-center">
                <h4 className="text-lg">{isData?.data?.result.title}</h4>
              </div>
            </div>
          </div>
        </>
      ) : null}
      <h4 className="font-semibold text-blue text-base uppercase tracking-wider mb-5">
        Personal Information
      </h4>
      <div className="grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2 mb-10">
        <div className="form-group sm:!mb-1 !mb-0">
          <label htmlFor="first_name" className="field-label mb-2">
            First Name <span className="text-red-600">*</span>
          </label>
          <InputForm
            type="text"
            id="first_name"
            name="first_name"
            placeholder="Enter First Name"
            withFormik={true}
            formik={formik}
            parentClassName="w-full"
          />
        </div>
        <div className="form-group sm:!mb-1 !mb-0">
          <label htmlFor="first_name" className="field-label mb-2">
            Middle Name
          </label>
          <InputForm
            type="text"
            id="middle_name"
            name="middle_name"
            placeholder="Enter Middle Name"
            withFormik={true}
            formik={formik}
            parentClassName="w-full"
          />
        </div>
        <div className="form-group sm:!mb-1 !mb-0">
          <label htmlFor="first_name" className="field-label mb-2">
            Last Name <span className="text-red-600">*</span>
          </label>
          <InputForm
            type="text"
            id="last_name"
            name="last_name"
            placeholder="Enter Last Name"
            withFormik={true}
            formik={formik}
            parentClassName="w-full"
          />
        </div>
        <div className="form-group sm:!mb-1 !mb-0">
          <label className="field-label mb-2">
            Contact No. <span className="text-red-600">*</span>
          </label>
          <InputForm
            type="text"
            id="contact_no"
            name="contact_no"
            placeholder="Enter Contact No."
            withFormik={true}
            formik={formik}
            parentClassName="w-full"
          />
        </div>
        <div className="form-group sm:!mb-1 !mb-0">
          <label htmlFor="first_name" className="field-label mb-2">
            Gender <span className="text-red-600">*</span>
          </label>
          <select
            name="gender"
            id="gender"
            className="form-control"
            onChange={(e) => {
              // handleChange(e)
              const { name, value } = e.target;
              console.log("gender", value);
              formik.setFieldValue("gender", value);
            }}
            value={formik.values?.gender}
            onBlur={formik.handleBlur}
          >
            <option value="">- Select Gender -</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
          <div className="help-block text-red-500 text-sm mt-2">
            {formik.touched.gender && formik.errors.gender && (
              <div>{formik.errors.gender}</div>
            )}
          </div>
        </div>
      </div>

      {/* USER ROLES */}
      {[1, 2, 13, 14, 16, 17].includes(UserSession?.result?.user_role_id) ? (
        <>
          <h4 className="font-semibold text-blue text-base uppercase tracking-wider mb-5">
            User Access Level
          </h4>
          <div className="grid md:grid-cols-2 grid-cols-1 sm:gap-4 gap-2 mb-10">
            <div className="form-group sm:!mb-1 !mb-0">
              <label htmlFor="first_name" className="field-label mb-2">
                User Role <span className="text-red-600">*</span>
              </label>
              {router?.route == "/app/doctors" ? (
                <input
                  type="text"
                  name="user_role_id"
                  id="user_role_id"
                  className="form-control"
                  readOnly
                  onChange={(e) => {
                    formik.setFieldValue("user_role_id", 7);
                  }}
                  defaultValue={doctor_name}
                  onBlur={formik.handleBlur}
                />
              ) : (
                <select
                  name="user_role_id"
                  id="user_role_id"
                  defaultValue={
                    !isEmpty(userRoles?.data) &&
                    formik.values?.user_role_id &&
                    formik.values.user_role_id
                  }
                  value={formik.values?.user_role_id}
                  className="form-control"
                  onChange={(e) => {
                    // handleChange(e)
                    const { name, value } = e.target;
                    formik.setFieldValue("user_role_id", value);
                    formik.setFieldValue(
                      "user_role_name",
                      userRoles?.data?.find((item) => item.id == value)?.name
                    );
                  }}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select user role</option>

                  {userRoles?.data &&
                    !isEmpty(userRoles.data) &&
                    userRoles.data.map((userRole) => (
                      <option key={"ls-" + userRole.id} value={userRole.id}>
                        {userRole.name}
                      </option>
                    ))}
                </select>
              )}
              <div className="help-block text-red-500 mt-2">
                {formik.touched.user_role_id && formik.errors.user_role_id && (
                  <div>{formik.errors.user_role_id}</div>
                )}
              </div>
            </div>
            {formik.values.user_role_id == 15 ||
            router?.route == "/app/doctors" ? (
              <div className="form-group sm:!mb-1 !mb-0">
                <label className="field-label mb-2">
                  License No. <span className="text-red-600">*</span>
                </label>
                <InputForm
                  type="text"
                  id="license_no"
                  name="license_no"
                  placeholder="License No.*"
                  withFormik={true}
                  formik={formik}
                  parentClassName="w-full"
                />
              </div>
            ) : null}
          </div>

          {formik.values.user_role_id == 15 ||
          router?.route == "/app/doctors" ? (
            <div className="form-group sm:!mb-1 !mb-0">
              <label className="field-label block mb-3">
                Service Type <span className="text-red-600">*</span>
              </label>
              <div className="form-group">
                <label className="checkbox-form-group">
                  <div className="grid md:grid-cols-2 grid-cols-1 gap-3">
                    <div className="col-span-1">
                      {ServicesData.data.result.map((service, i) => (
                        <label key={i} className="block mb-3">
                          {service.category == "Adult" ? (
                            <>
                              <input
                                className="checkbox-form-control"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setcheckedServices(
                                      produce((draft) => {
                                        draft.push({
                                          // "name": service.name,
                                          service_id: service.id,
                                        });
                                      })
                                    );
                                  } else {
                                    setcheckedServices(
                                      produce((draft) => {
                                        draft.splice(
                                          draft.findIndex(
                                            (service) =>
                                              service.service_id === service.id
                                          ),
                                          1
                                        );
                                      })
                                    );
                                  }
                                }}
                                // value={formik.values?.name}
                                name={service.name}
                                id={service.name}
                                type="checkbox"
                              />
                              {service.category} - {service.name}
                            </>
                          ) : null}
                        </label>
                      ))}
                    </div>
                    <div className="col-span-1">
                      {ServicesData.data.result.map((service, i) => (
                        <label key={i} className="block mb-3">
                          {service.category == "Child and Adolescent" ? (
                            <>
                              <input
                                className="checkbox-form-control"
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setcheckedServices(
                                      produce((draft) => {
                                        draft.push({
                                          // "name": service.name,
                                          service_id: service.id,
                                        });
                                      })
                                    );
                                  } else {
                                    setcheckedServices(
                                      produce((draft) => {
                                        draft.splice(
                                          draft.findIndex(
                                            (service) =>
                                              service.service_id === service.id
                                          ),
                                          1
                                        );
                                      })
                                    );
                                  }
                                }}
                                // value={formik.values?.name}
                                name={service.name}
                                id={service.name}
                                type="checkbox"
                              />
                              <span className="">
                                {service.category} - {service.name}
                              </span>
                            </>
                          ) : null}
                        </label>
                      ))}
                    </div>

                    {checkedServices.length === 0 ? (
                      <div className={`help-block text-red-400 mt-2`}>
                        Service Type is required
                      </div>
                    ) : null}
                  </div>
                </label>
              </div>
            </div>
          ) : null}
        </>
      ) : null}

      <h4 className="font-semibold text-blue text-base uppercase tracking-wider mb-5">
        Account Information
      </h4>
      <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-4 gap-2 mb-4">
        <div className="form-group sm:!mb-1 !mb-0">
          <label className="field-label mb-2">
            Email <span className="text-red-600">*</span>
          </label>
          <InputForm
            type="email"
            id="email"
            name="email"
            placeholder="Email Address*"
            withFormik={true}
            formik={formik}
            helpBlockClass={"text-red-400"}
            helpBlockText={SchemaErrors?.username && SchemaErrors.username}
          />
        </div>
        <div className="form-group sm:!mb-1 !mb-0">
          <label className="field-label mb-2">
            Password <span className="text-red-600">*</span>
          </label>
          <InputForm
            type="password"
            id="password"
            name="password"
            placeholder="Password*"
            withFormik={true}
            formik={formik}
          />
        </div>
      </div>
      <div className="form-group">
        {formMessage != "" ? (
          <div className={`mt-1 mb-2 ${formMessageType}`}>{formMessage}</div>
        ) : null}
      </div>
      <div className="flex items-center justify-end flex-wrap gap-3">
        <button
          type="button"
          onClick={() => onClose()}
          className="btn btn-dash-cancel"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={isLoading ? true : false}
          className="btn btn-dash-primary"
        >
          <Spinner isLoading={isLoading} />
          {!isLoading && "Submit"}
        </button>
      </div>
    </form>
  );
};

AddUserModal.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  successCallback: PropTypes.func.isRequired,
  errorCallback: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default AddUserModal;
